import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Modal from 'reboron/DropModal'

import Sentiment from './Sentiment'
import GradeLevelScores from './GradeLevelScores'

import { isNotViewingReadabilityScoresModal } from '../../../actions/modal'
import {
  averageGradeLevel,
  thisDataIsNotCurrentlyAvailable
} from '../../../utils/messages'
import { isNullOrEmpty, getClassNameFromText } from '../../../utils'
import {
  getSectionScores,
  getDisplayAverageGradeLevelLabel,
  formatReadingTime,
  parseLongestSentenceWordCount
} from '../../../utils/readability'

export default class ReadabilityModal extends Component {
  constructor() {
    super()
    this.closeModalBound = this.closeModal.bind(this)
    this.onClickToCloseModalBound = this.onClickToCloseModal.bind(this)
  }

  componentDidMount() {
    this.showModal()
    document.getElementsByTagName('html')[0].style.overflow = 'hidden'
  }

  componentWillUnmount() {
    document.getElementsByTagName('html')[0].style.overflow = 'scroll'
    this.props.dispatch(isNotViewingReadabilityScoresModal())
  }

  render() {
    const modalStyle = {
      maxHeight: 'calc(100% - 100px)',
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '712px',
      minHeight: '375px',
      background: '#fff',
      overflow: 'visible',
      borderRadius: '5px',
      padding: '13px 24px 40px'
    }

    const contentStyle = {
      backgroundColor: '#fff',
      height: '100%',
      outline: 'none'
    }

    const { quest, section, subsection, activity } = this.props
    const readableObject = section === 'activity' ? activity : quest
    const scores = getSectionScores(readableObject, subsection)

    return (
      <Modal
        ref="modal"
        className={'readability-modal'}
        modalStyle={modalStyle}
        contentStyle={contentStyle}
        closeOnClick={true}
        onHide={this.closeModalBound}
      >
        <div>
          <div className="top">
            <div className="header-container">
              <div className="header">
                <FormattedMessage
                  id={'ReadabilityModal.Readability'}
                  defaultMessage={'Readability'}
                />
              </div>
              <div className="section">
                {section.concat(' ').concat(subsection.replace(/_/g, ' '))}
              </div>
            </div>
            <div
              className="close-icon"
              onClick={this.onClickToCloseModalBound}
            />
          </div>

          <div className="line" />

          <div className="bottom">
            <div className="left">
              <div className="average-grade-level">
                <div className="book-icon" />
                <div className="grade-level-container">
                  <div className="score">
                    {isNullOrEmpty(scores.stats.average_grade_level) ? (
                      <span>&mdash;</span>
                    ) : (
                      scores.stats.average_grade_level
                    )}
                  </div>
                  <div className="readability-label">{averageGradeLevel}</div>
                </div>
              </div>
              <div className="average-grade-name">
                {isNullOrEmpty(scores.stats.average_grade_level_label)
                  ? this.renderNotAvailable()
                  : getDisplayAverageGradeLevelLabel(
                      scores.stats.average_grade_level_label
                    )}
              </div>

              {scores.stats.average_grade_level_scores && (
                <GradeLevelScores
                  gradeLevelScores={scores.stats.average_grade_level_scores}
                />
              )}

              <div className="link">
                <a target="_blank" href="https://readable.io/">
                  Learn more
                </a>{' '}
                about these scores.
              </div>
            </div>

            <div className="right">
              <Sentiment
                sentiment={scores.stats.sentiment}
                klass={
                  scores.stats.sentiment
                    ? getClassNameFromText(scores.stats.sentiment)
                    : 'no-score'
                }
                renderNotAvailable={this.renderNotAvailable()}
              />
              <div className="reading-time">
                <div className="score">
                  {isNullOrEmpty(scores.stats.reading_time) ? (
                    <span>&mdash;</span>
                  ) : (
                    formatReadingTime(scores.stats.reading_time)
                  )}
                </div>
                <div className="readability-label">
                  <FormattedMessage
                    id={'ReadabilityModal.ReadingTime'}
                    defaultMessage={'Reading Time'}
                  />
                </div>
                {isNullOrEmpty(scores.stats.reading_time) &&
                  this.renderNotAvailable()}
              </div>

              <div className="longest-sentence-container">
                <div className="score">
                  {isNullOrEmpty(scores.stats.longest_sentence_words) ? (
                    <span>&mdash;</span>
                  ) : (
                    parseLongestSentenceWordCount(
                      scores.stats.longest_sentence_words
                    ).wordCount
                  )}
                </div>
                <div className="readability-label">
                  <FormattedMessage
                    id={'ReadabilityModal.LongestSentenceByWordCount'}
                    defaultMessage={'Longest Sentence by Word Count'}
                  />
                </div>
                <div className="longest-sentence">
                  {isNullOrEmpty(scores.stats.longest_sentence_words)
                    ? this.renderNotAvailable()
                    : parseLongestSentenceWordCount(
                        scores.stats.longest_sentence_words
                      ).longestSentence}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    )
  }

  renderNotAvailable() {
    return (
      <div className="not-available">{thisDataIsNotCurrentlyAvailable}</div>
    )
  }

  showModal() {
    this.refs.modal.show()
  }

  closeModal() {
    this.props.dispatch(isNotViewingReadabilityScoresModal())
  }

  onClickToCloseModal() {
    this.refs.modal.hide()
  }
}

ReadabilityModal.propTypes = {
  quest: PropTypes.object.isRequired,
  section: PropTypes.string.isRequired,
  subsection: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  activity: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/quest/readability/ReadabilityModal.js